$( document ).on("turbo:load", initPositionList);

function initPositionList() {
  $('ul.position-list').sortable({ axis: "y", 
                                   containment: "document",
                                   placeholder: "list-group-item position-list-placeholder",
                                   handle: '.position-list-handle',
                                   forcePlaceholderSize: true,
                                   create: function(event,ui) { addHandles(this); sort(this); },
                                   stop: function(event,ui) { updatePositions(this); }
  });
}

function addHandles(list) {
  $(list).find('li').each(function(index, element) {
    $(element).find('.position-list-handle').remove();
    $(element).prepend('<i class="glyphicon glyphicon-sort position-list-handle" />');
  });
}

function updatePositions(list) {
  $(list).find('li').each(function(index, element) {
    $(element).find('input.position').val(index+1);
  });
}

function sort(list) {
  $(list).find('li').sortElements(function(a,b) {
    aPosition = $(a).find('input.position').val();
    bPosition = $(b).find('input.position').val();
    return parseInt(aPosition) > parseInt(bPosition) ? 1 : -1;
  });
}

jQuery.fn.sortElements = (function(){
    var sort = [].sort;
    return function(comparator, getSortable) {
        getSortable = getSortable || function(){return this;};
        var placements = this.map(function(){
            var sortElement = getSortable.call(this),
                parentNode = sortElement.parentNode,
                nextSibling = parentNode.insertBefore(
                    document.createTextNode(''),
                    sortElement.nextSibling
                );
            return function() {
                if (parentNode === this) {
                    throw new Error(
                        "You can't sort elements if any one is a descendant of another."
                    );
                }
                parentNode.insertBefore(this, nextSibling);
                parentNode.removeChild(nextSibling);
            };
        });
        return sort.call(this, comparator).each(function(i){
            placements[i].call(getSortable.call(this));
        });
    };
})();
